import React from "react";
import "../css/DataAnalytique.css";
import dataImg from "../assets/images/analytique.jpg";
import dataImgEn from "../assets/images/ApproachEn.jpg";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

export default function DataAnalytique() {
  const { t, language } = useLanguage();
  const navigate = useNavigate();
  
  const handleNavigate = () => {
    navigate("/dataIntelligence");
    // Utiliser setTimeout pour s'assurer que la page est chargée avant de scroller
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };
  
  // Utiliser l'image anglaise si la langue est 'en', sinon l'image française
  const analytiqueImage = language === 'en' ? dataImgEn : dataImg;
  return (
    <section className="data-section">
      {/* TITRE PRINCIPAL */}
      <h1 className="data-title"
        dangerouslySetInnerHTML={{ __html: t('dataAnalytique.title') }}
      />
      {/* IMAGE */}
      <img src={analytiqueImage} alt={t('dataAnalytique.alt')} className="data-img" />
      {/* SOUS-TITRE */}
      <p className="data-subtitle"
        dangerouslySetInnerHTML={{ __html: t('dataAnalytique.subtitle') }}
      />

      {/* TEXTE */}
      <div className="data-content">
        <p>
          {t('dataAnalytique.description')}
        </p>
      </div>

      {/* LIEN */}
      <button
        className="data-link"
        onClick={handleNavigate}
      >
        {t('dataAnalytique.button')}
      </button>
    </section>
  );
}
